import { render, staticRenderFns } from "./TableMusicYx.vue?vue&type=template&id=38b6abda&scoped=true&"
import script from "./TableMusicYx.vue?vue&type=script&lang=js&"
export * from "./TableMusicYx.vue?vue&type=script&lang=js&"
import style0 from "./TableMusicYx.vue?vue&type=style&index=0&id=38b6abda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b6abda",
  null
  
)

export default component.exports